import config from 'config';
import { APIResponse } from 'types/Cokiba';

export interface News {
  id: number;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

type GetNewsResponse = APIResponse<News[]>;
type DeleteNewsResponse = APIResponse<undefined>;
type CreateNewsResponse = APIResponse<News>;
type UpdateNewsResponse = APIResponse<News>;

export async function getNews(): Promise<News[]> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return [];
    }

    const url = new URL(`${ config.baseUrl }/contents/news`);
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status !== 200) {
      return [];
    }

    const content = await response.json() as GetNewsResponse;
    const { payload } = content;

    return payload || [];
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las novedades. ');
  }
}

export async function deleteNews(id: number): Promise<boolean> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    const url = new URL(`${ config.baseUrl }/contents/news/${ id }`);
    const response = await fetch(url.toString(), {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status !== 200) {
      return false;
    }

    const content = await response.json() as DeleteNewsResponse;
    const { status } = content;

    return status == 'ok';
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las novedades. ');
  }
}

export async function createNews(news: News): Promise<News | false> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    const { id: _, ...data } = news;

    const url = new URL(`${ config.baseUrl }/contents/news`);
    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });

    if (response.status !== 200) {
      return false;
    }

    const content = await response.json() as CreateNewsResponse;
    const { payload } = content;

    return payload || false;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las novedades. ');
  }
}

export async function updateNews(news: News): Promise<News | false> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    const { id, ...data } = news;

    const url = new URL(`${ config.baseUrl }/contents/news/${ id }`);
    const response = await fetch(url.toString(), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });

    if (response.status !== 200) {
      return false;
    }

    const content = await response.json() as UpdateNewsResponse;
    const { payload } = content;

    return payload || false;
  } catch (err) {
    throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las novedades. ');
  }
}
